import { CardCaracter } from "../../element/Card";
import {useState, useEffect, useMemo} from 'react'
import { db } from '../../firebase/FirebaseConfig';
import {collection, getDocs, query, where} from 'firebase/firestore';
import { auth } from '../../firebase/FirebaseConfig';
import { Tribe } from '../../List/TribeList'
import Loader from '../../element/Loader'
import {  View, FlatList, ScrollView} from 'react-native-web'
import { TextInput1 } from "../../element/TextInput";



const PgList = ({navigation}) => {
    const [characters, setChatacters]=useState([])
    const [flip, setFlip]=useState(false)
    const [ricerca, setRicerca]= useState('')
    const Master=true
    const user= auth.currentUser

    
useEffect(()=>{
    const unsubscribe = navigation.addListener('focus', () => {
        kimera()
      });
    
     
    
},[navigation])
  
async function kimera(){
    
    let png=[]
    let information=query(collection(db,"personaggi"));
    let querySnapshot= await getDocs(information);
          querySnapshot.forEach((docs)=>{png.push(docs.data());});
          setTimeout(3000)
          png.sort((a,b)=>{
            if (a.Tribe === b.Tribe) {
              return a.Name.localeCompare(b.Name);
            }
            return a.Tribe.localeCompare(b.Tribe);
          })
          console.log(...png)
          setChatacters([...png])
          setFlip(true)   
}
                                
function List(){

  const filteredData = ricerca.trim() === '' ? characters : characters.filter (item => {
      const values = Object.values(item).map(value => value.toString().toLowerCase());
      return values.some(value => value.includes(ricerca.toLowerCase()));
    });





  return (
     
<View style={{alignItems:'center', flex:1, marginBottom:15 }}>    
       <TextInput1
            value={ricerca}
            onChangeText={(text) => {
              setRicerca(text);
            }}
            secure={false}
            placeholder={'cerca'}
       
          />
   
    <FlatList
     data={filteredData}
     keyExtractor={(item)=>item.Key}
     showsVerticalScrollIndicator={true}
     
     contentContainerStyle={{marginVertical:15, marginTop:35 }}
     renderItem={({ item }) => (
      <ScrollView style={{paddingVertical:15}}>   
     {item.Death? <CardCaracter Name={item.Name} tribeImage={require('../../../assets/skull.png')} Complete={'MORTO'} color2={'grey'} onPress={()=>{navigation.navigate('DetailSheet',{item, Master})}}/>: <CardCaracter Name={item.Name} tribeImage={Tribe[Tribe.findIndex((obj)=>obj.name===item.Tribe)].image} Complete={item.Complete} color2={'#F9BA49'} onPress={()=>{navigation.navigate('DetailSheet',{item, Master})}}/>}
      </ScrollView>
      )}/> 
   </View>  
     
  )
}

return(
<View style={{width:'100%', height:'100%'}}>{flip? <List/>:<View style={{width:'100%', height:'100%', alignItems:'center', justifyContent:'center'}}><Loader/></View>}</View>


);}

export default PgList